<template>
  <scout-tab-panel
    :is-active="isActive"
    title="本日のおすすめ"
    name="pickup"
    :link="link"
    tooltip="アクティブで応募につながり易い会員を自動抽出します。"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'

export default {
  components: { ScoutTabPanel },
  computed: {
    isActive () {
      return this.$route.path.includes('/recommended')
    },
    link () {
      return { name: 'scoutRecommended' }
    }
  }
}

</script>
